//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';
import SolicitudManager from '../../../Common/Managers/SolicitudManager';
import ClienteManager from '../../../Common/Managers/ClienteManager';

//Import del reducer de DistribucionLimites.
import distribucionLimitesReducer from '../../../Store/Reducers/DistribucionLimites';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

//Dispatch global para dispatchear desde funciones complementarias
let _dispatch = null;
let _tarjetas = null;
let userFeatures, userFunctions = [];

/**
 * Constantes de acciones a dispatchear
 */
export const SET_PERMISOS_SOLICITUD_TARJETA = 'SET_PERMISOS_SOLICITUD_TARJETA';
export const GET_ACCOUNT_DATA_RESULT = 'GET_ACCOUNT_DATA_RESULT';
export const RESET_STATE_SOLICITUD_TARJETA = 'RESET_STATE_SOLICITUD_TARJETA';
export const GET_ACCOUNT_DATA = 'GET_ACCOUNT_DATA';
export const GET_ACCOUNT_DATA_FINALLY = 'GET_ACCOUNT_DATA_FINALLY';
export const ABRIR_COMBO_DIAS_SOLICITUD_TARJETAS = 'ABRIR_COMBO_DIAS_SOLICITUD_TARJETAS';
export const COUNT_CARD = 'COUNT_CARD';
export const GET_HEADLINE = 'GET_HEADLINE';
export const OBTENER_DIAS_SOLICITUD_TARJETAS = 'OBTENER_DIAS_SOLICITUD_TARJETAS';
export const OBTENER_TIPO_TARJETA_SOLICITUD_TARJETAS = 'OBTENER_TIPO_TARJETA_SOLICITUD_TARJETAS';
export const OBTENER_LIMITES_TARJETA_SOLICITUD_TARJETAS = 'OBTENER_LIMITES_TARJETA_SOLICITUD_TARJETAS';
export const GET_RADIO_BUTTON = 'GET_RADIO_BUTTON';
export const OBTENER_DENOMINACION_SOLICITUD_TARJETAS = 'OBTENER_DENOMINACION_SOLICITUD_TARJETAS';
export const CHANGE_TO_SELECT_CARD = 'CHANGE_TO_SELECT_CARD';
export const EDITAR_FILA_SOLICITUD_TARJETAS = 'EDITAR_FILA_SOLICITUD_TARJETAS';
export const SHOW_ERROR = 'SHOW_ERROR';
export const SHOW_ERROR_DATA = 'SHOW_ERROR_DATA';
export const ELIMINAR_FILA_SOLICITUD_TARJETAS = 'ELIMINAR_FILA_SOLICITUD_TARJETAS';
export const VALIDATE_ALPHA_ONLY = 'VALIDATE_ALPHA_ONLY';
export const GUARDAR_SOLICITUD = 'GUARDAR_SOLICITUD';
export const CONSULTAR_NOMBRE_O_DOCUMENTO = 'CONSULTAR_NOMBRE_O_DOCUMENTO';
export const GUARDAR_SOLICITUD_BORRADOR_SOLICITUD_TARJETAS = 'GUARDAR_SOLICITUD_BORRADOR_SOLICITUD_TARJETAS';
export const OBTENER_TITULAR_SOLICITUD_TARJETAS = 'OBTENER_TITULAR_SOLICITUD_TARJETAS';
export const ROUTE_TO_CONFIRMACION_FROM_TARJETA = 'ROUTE_TO_CONFIRMACION_FROM_TARJETA';
export const ROUTE_TO_VISTACLIENTE_FROM_TARJETA = 'ROUTE_TO_VISTACLIENTE_FROM_TARJETA';
export const ACTUALIZAR_ESTADO_GLOBAL_TARJETA = 'ACTUALIZAR_ESTADO_GLOBAL_TARJETA';
export const OPEN_MODAL_DISTRIBUIRLIMITES_TARJETA = "OPEN_MODAL_DISTRIBUIRLIMITES_TARJETA";
export const CLOSE_MODAL_DISTRIBUIRLIMITES_TARJETA = "CLOSE_MODAL_DISTRIBUIRLIMITES_TARJETA";
export const ACTUALIZAR_LIMITES_TARJETA = "ACTUALIZAR_LIMITES_TARJETA";
export const ACTUALIZAR_ESTADO_DISTRIBUCION_TARJETA = 'ACTUALIZAR_ESTADO_DISTRIBUCION_TARJETA';
export const VALIDAR_ERROR_SOLICITUD_TARJETAS = 'VALIDAR_ERROR_SOLICITUD_TARJETAS';
export const SELECCIONAR_CODIGO_DISTRIBUCION = 'SELECCIONAR_CODIGO_DISTRIBUCION';
export const FRENAR_SPINNER_SOLICITUD_TARJETAS = 'FRENAR_SPINNER_SOLICITUD_TARJETAS';

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch, getState) => {
        _tarjetas = JSON.parse(JSON.stringify(getState().tarjetas));
        _dispatch = dispatch;

        dispatch({ type: GET_ACCOUNT_DATA, _tarjetas });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadFunctions(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * Action que valida al guardar una tarjeta.
 * @param {any} dataCard
 * @param {any} form
 */
export function validateAddCard(dataCard, form) {
    LogHelper.In(validateAddCard.name, dataCard, form);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        let data = getState();
        let valids = [];
        let denominacionTarjeta;
        form.validateFields((error, value) => {
            if (error == null) {
                return;
            }

            if (data.nuevaSolicitudTarjeta.denominationCard != "") {
                error.denominacionTarjeta = undefined;
                delete error.denominacionTarjeta;
            }

            dataCard.ERROR_CARD["denominacionTarjeta"] = (error.denominacionTarjeta == undefined);
            valids.push(dataCard.ERROR_CARD["denominacionTarjeta"]);
        });

        let seleccionoTitular = dataCard.titularCard != undefined;
        dataCard.ERROR_CARD["seleccionoTitular"] = seleccionoTitular;
        valids.push(seleccionoTitular);

        dataCard.idTipoTarjeta = dataCard.idTipoTarjeta == null ? 0 : dataCard.idTipoTarjeta;
        dataCard.idTipoTarjeta = dataCard.idTipoTarjeta == undefined ? 0 : dataCard.idTipoTarjeta;

        let seleccionoTipoTarjeta = (dataCard.idTipoTarjeta != 0);
        dataCard.ERROR_CARD["seleccionoTipoTarjeta"] = seleccionoTipoTarjeta;
        valids.push(seleccionoTipoTarjeta);

        let seleccionoCodigoDistribucion = dataCard.codigoDistribucion != undefined;
        dataCard.ERROR_CARD["codigoDistribucion"] = seleccionoCodigoDistribucion;
        valids.push(seleccionoCodigoDistribucion);

        if (data.nuevaSolicitudTarjeta.modalidadDistribucionLimiteIdEncuentaSeleccionada > 1) {
            if (data.nuevaSolicitudTarjeta.modalidadDistribucionLimiteIdEncuentaSeleccionada == 3) {
                dataCard.ERROR_CARD["limiteSuperado"] = (parseInt(dataCard.limite) > 100);

                valids.push(!dataCard.ERROR_CARD["limiteSuperado"]);
            } else {
                let limiteCompraIngresado = (!(dataCard.limite == undefined || dataCard.limite == ""));
                dataCard.ERROR_CARD["limiteCompra"] = limiteCompraIngresado;
                valids.push(dataCard.ERROR_CARD["limiteCompra"]);

                let limiteDisponible = 0;
                data.nuevaSolicitudTarjeta.tarjetasFiltradas.forEach((tarjeta) => {
                    let nuevoLimite = tarjeta.PorcentajeLimiteCompra || tarjeta.Limite;
                    //Si la tarjeta es sin limites o no tiene un valor, le seteo en 0
                    if (nuevoLimite == undefined || nuevoLimite == null) {
                        nuevoLimite = 0;
                    }

                    if (data.nuevaSolicitudTarjeta.tarjetaAeditar) {
                        if (data.nuevaSolicitudTarjeta.tarjetaAeditar.IdReferencia != tarjeta.IdReferencia) {
                            limiteDisponible += parseInt(nuevoLimite);
                        }
                    } else {
                        limiteDisponible += parseInt(nuevoLimite);
                    }
                });

                let limiteSuperado = (limiteDisponible + (parseInt(dataCard.limite)) > 100);
                dataCard.ERROR_CARD["limiteSuperado"] = limiteSuperado;

                valids.push(!dataCard.ERROR_CARD["limiteSuperado"]);
            }
        }
        else if (data.nuevaSolicitudTarjeta.modalidadDistribucionLimiteIdEncuentaSeleccionada == 3) {
            dataCard.ERROR_CARD["limiteSuperado"] = (parseInt(dataCard.limite) > 100);

            valids.push(!dataCard.ERROR_CARD["limiteSuperado"]);
        }

        if (_tarjetas.cuentas.find(x => x.seleccionada).checkDescentralizada) {
            dataCard.ERROR_CARD["limiteValido"] = (parseInt(dataCard.valor) < dataCard.minValueLimite);
            valids.push(!dataCard.ERROR_CARD["limiteValido"]);
        }

        if (dataCard.checkTempCard) {
            if (dataCard.vigencia) {
                dataCard.ERROR_CARD["vigenciaValida"] = (dataCard.vigencia.id > 0);
            } else {
                dataCard.ERROR_CARD["vigenciaValida"] = false;
            }

            valids.push(dataCard.ERROR_CARD["vigenciaValida"]);
        }

        let validate = true;

        for (let valid of valids) {
            if (!valid) {
                validate = false;
                break;
            }
        }

        if (validate) {
            dispatch({ type: COUNT_CARD });


            dispatch({
                type: ACTUALIZAR_ESTADO_GLOBAL_TARJETA,
                tarjetas: getState().nuevaSolicitudTarjeta.tarjetas
            });

        } else {
            dispatch({ type: VALIDAR_ERROR_SOLICITUD_TARJETAS });
        }

    }
}

/**
 * Reset del state de la pantalla.
 */
export function resetStateSolicitudTarjeta() {
    LogHelper.In(resetStateSolicitudTarjeta.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_STATE_SOLICITUD_TARJETA });
    }
}

/**
 * 
 */
export function openDays() {
    LogHelper.In(openDays.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ABRIR_COMBO_DIAS_SOLICITUD_TARJETAS });
    }
}

/**
 * 
 */
export function countCard() {
    LogHelper.In(countCard.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: COUNT_CARD });
    }
}

/**
 * 
 * @param {any} headline
 */
export function getHeadline(headline, tipoDocumento) {
    LogHelper.In(getHeadline.name, headline, tipoDocumento);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = getState();

        _obtenerTitular(headline, state.nuevaSolicitudTarjeta, tipoDocumento);
    }
}

/**
 * 
 * @param {any} kind
 */
export function getKind(kind) {
    LogHelper.In(getKind.name, kind);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        let state = getState();
        dispatch({ type: OBTENER_TIPO_TARJETA_SOLICITUD_TARJETAS, valueKind: kind, data: state });
    }
}

/**
 * 
 * @param {any} limit
 */
export function getLimit(limit) {
    LogHelper.In(getLimit.name, limit);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: OBTENER_LIMITES_TARJETA_SOLICITUD_TARJETAS, valueLimit: limit });
    }
}

/**
 * 
 * @param {any} idDays
 */
export function getDays(idDays) {
    LogHelper.In(getDays.name, idDays);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: OBTENER_DIAS_SOLICITUD_TARJETAS, valueIdDays: idDays });
    }
}

/**
 * 
 * @param {any} idDenom
 */
export function getDenomination(idDenom) {
    LogHelper.In(getDenomination.name, idDenom);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: OBTENER_DENOMINACION_SOLICITUD_TARJETAS, valueDenom: idDenom });
    }
}

/**
 * 
 */
export function routeToNuevaSolicitudConfirmacion() {
    LogHelper.In(routeToNuevaSolicitudConfirmacion.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: ACTUALIZAR_ESTADO_GLOBAL_TARJETA,
            tarjetas: getState().nuevaSolicitudTarjeta.tarjetas
        });

        dispatch({
            type: ROUTE_TO_CONFIRMACION_FROM_TARJETA,
            idSolicitud: getState().tarjetas.id
        });
    }
}

/**
 * 
 */
export function routeToPrevious() {
    LogHelper.In(routeToPrevious.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: ROUTE_TO_CUENTA
        });
    }
}

/**
 * 
 */
export function routingNext() {
    LogHelper.In(routingNext.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ROUTE_TO_CONFIRMACION });
    }
}

/**
 * 
 */
export function routingPrevious() {
    LogHelper.In(routingPrevious.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ROUTE_TO_CUENTA });
    }
}

/**
 * 
 */
export function routeToCancel() {
    LogHelper.In(routeToCancel.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ROUTE_TO_CANCEL });
    }
}

/**
 * 
 */
export function changeToSelectCard() {
    LogHelper.In(changeToSelectCard.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CHANGE_TO_SELECT_CARD });
    }
}

/**
 * 
 * @param {any} row
 */
export function editDate(row) {
    LogHelper.In(editDate.name, row);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: EDITAR_FILA_SOLICITUD_TARJETAS, valueRow: row });
    }
}

/**
 * 
 * @param {any} id
 */
export function deleteDate(id) {
    LogHelper.In(deleteDate.name, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: ELIMINAR_FILA_SOLICITUD_TARJETAS, valueId: id });

        dispatch({
            type: ACTUALIZAR_ESTADO_GLOBAL_TARJETA,
            tarjetas: getState().nuevaSolicitudTarjeta.tarjetas
        });
    }
}

/**
 * 
 * @param {any} search
 */
export function searchTitular(search) {
    LogHelper.In(searchTitular.name, search);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: FILTER_SEARCH_TITULAR, valueSearch: search });
    }
}

/**
 * 
 */
export function showError() {
    LogHelper.In(showError.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SHOW_ERROR });
    }
}

/**
 * 
 */
export function showErrorData() {
    LogHelper.In(showErrorData.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SHOW_ERROR_DATA });
    }
}

/**
 * 
 */
export function routeToLimits() {
    LogHelper.In(routeToLimits.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ROUTE_TO_LIMITES });
    }
}

/**
 * 
 * @param {any} solicitud
 */
export function guardarSolicitudBorrador() {
    LogHelper.In(guardarSolicitudBorrador.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let promise = new Promise((resolve) => {
            resolve(dispatch({ type: ACTUALIZAR_ESTADO_GLOBAL_TARJETA, tarjetas: getState().nuevaSolicitudTarjeta.tarjetas }));
        });

        promise.then(() => {
            _tarjetas = JSON.parse(JSON.stringify(getState().tarjetas));
            SolicitudManager.GuardarSolicitudBorrador(_tarjetas, (data) => guardarSolicitudBorradorCallback(data, dispatch));
        });
    }
}

export function closeModal() {
    $('.modal').modal('hide');
}

/**
 * 
 * @param {any} denomination
 * @param {any} isValid
 */
export function validateAlphaOnly(denomination, isValid) {
    LogHelper.In(validateAlphaOnly.name, denomination, isValid);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: VALIDATE_ALPHA_ONLY, valueDenomination: denomination, valueIsValid: isValid });
    }
}
/**
 * Abre el modal de distribuir limites.
 */
export function openModalDistribucionLimites() {
    LogHelper.In(openModalDistribucionLimites.name);

    return (dispatch) => {
        //Inyecto el reducer de distribucionLimites.
        const reducers = [];
        reducers.push(distribucionLimitesReducer);
        dispatch({ type: 'STORE_INJECT', reducers: reducers });

        dispatch({ type: OPEN_MODAL_DISTRIBUIRLIMITES_TARJETA });
    }
}
/**
 * Cierra el modal de distribuir limites.
 */
export function closeModalDistribucionLimites() {
    LogHelper.In(closeModalDistribucionLimites.name);

    return (dispatch) => {
        dispatch({ type: CLOSE_MODAL_DISTRIBUIRLIMITES_TARJETA });
    }
}
/**
 * Actualiza los limites de la pantalla que invoca a la misma.
 * @param {any} estado
 */
export function actualizarLimites(estado) {
    LogHelper.In(actualizarLimites.name, estado);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: ACTUALIZAR_LIMITES_TARJETA,
            estado: estado
        });
    }
}
/**
 * 
 * @param {any} codigo
 * @param {any} id
 */
export function seleccionarCodigoDistribucion(codigo, id) {
    LogHelper.In(seleccionarCodigoDistribucion.name, { codigo, id });

    return (dispatch) => {
        dispatch({ type: SELECCIONAR_CODIGO_DISTRIBUCION, objDistribucion: { Codigo: codigo, Id: id } });
    }
}

/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

function guardarSolicitudBorradorCallback(data, dispatch) {
    LogHelper.In(guardarSolicitudBorradorCallback.name, data, dispatch);

    dispatch({ type: ROUTE_TO_VISTACLIENTE_FROM_TARJETA });
}

/**
 * Callback que setea las funciones del usuario
 * @param {any} data
 */
function _loadFunctions(data) {
    LogHelper.In(_loadFunctions.name, data);

    userFeatures = JSON.parse(JSON.stringify(data));

    let adminEmpCueTarFunctions = JSON.parse(JSON.stringify(data.ADMINEMPCUETAR));
    let adminEmpCueTarFunctionsAllowed = [];

    let solicitudFunctions = JSON.parse(JSON.stringify(data.SOLICITUD));
    let solicitudFunctionsAllowed = [];

    let permissions = {
        components: {
            Pantalla: { Active: false, Locked: false },
            IconoEditar: { Active: false, Locked: false },
            IconoEliminar: { Active: false, Locked: false },
            BotonesAnteriorSiguiente: { Active: false, Locked: false },
            BotonNuevaTarjeta: { Active: false, Locked: false },
            BotonDistribuirLimites: { Active: false, Locked: false },
            BotonGuardarBorrador: { Active: false, Locked: false }
        },
        adminEmpCueTarFunctionsAllowed: {},
        solicitudFunctionsAllowed: {}
    };

    adminEmpCueTarFunctions.forEach(p => { permissions.adminEmpCueTarFunctionsAllowed[p.Codigo_Funcion] = true; });
    solicitudFunctions.forEach(p => { permissions.solicitudFunctionsAllowed[p.Codigo_Funcion] = true; });

    if (_tarjetas.esModificacion == true) {
        //Chequear la validación del estado de la solicitud
        switch (_tarjetas.estadoSolicitud.toLowerCase()) {
            case "borrador": {
                if (permissions.solicitudFunctionsAllowed.Consulta == true) {
                    permissions.components.Pantalla.Active = true
                    permissions.components.BotonesAnteriorSiguiente.Active = true;
                    permissions.components.IconoEditar.Active = true;

                    if (permissions.solicitudFunctionsAllowed.Modificacion == true) {
                        permissions.components.BotonNuevaTarjeta.Active = true;
                        permissions.components.BotonGuardarBorrador.Active = true;
                        permissions.components.BotonDistribuirLimites.Active = true;
                    }
                    else {
                        if ((permissions.solicitudFunctionsAllowed.Distribucion == true)
                            || (permissions.solicitudFunctionsAllowed.Confirmacion == true)) {
                            permissions.components.BotonDistribuirLimites.Active = true;
                        }
                    }

                    if (permissions.solicitudFunctionsAllowed.Baja == true) {
                        permissions.components.IconoEliminar.Active = true;
                    }
                }
                else {
                    /*Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que 
                    no será capaz de acceder a la pantalla*/
                    permissions.components.Pantalla = { Active: false }
                };
                break;
            }
            case "cuenta / tarjeta parcialmente aceptada por adm":
            case "cuenta / tarjeta rechazada por adm":
            case "empresa rechazada por adm":
            case "denegada banco":
            case "completada":
            case "confirmada": {
                if (permissions.solicitudFunctionsAllowed.Consulta == true) {
                    permissions.components.Pantalla.Active = true
                    permissions.components.BotonesAnteriorSiguiente.Active = true;
                    permissions.components.IconoEditar.Active = true;
                    permissions.components.BotonDistribuirLimites.Active = true;

                    let completadaResult = _tarjetas.estadoSolicitud.toLowerCase() == "completada"
                        && (permissions.solicitudFunctionsAllowed.Modificacion == true);

                    let confirmadaResult = _tarjetas.estadoSolicitud.toLowerCase() == "confirmada"
                        && (permissions.solicitudFunctionsAllowed.Modificacion == true);

                    let denegadaResult = _tarjetas.estadoSolicitud.toLowerCase() == "denegada banco"
                        && (permissions.solicitudFunctionsAllowed.Modificacion == true);

                    let ctpResult = _tarjetas.estadoSolicitud.toLowerCase() == "cuenta / tarjeta parcialmente aceptada por adm"
                        && (permissions.solicitudFunctionsAllowed.Modificacion == true);

                    let ctrResult = _tarjetas.estadoSolicitud.toLowerCase() == "cuenta / tarjeta rechazada por adm"
                        && (permissions.solicitudFunctionsAllowed.Modificacion == true);

                    let erResult = _tarjetas.estadoSolicitud.toLowerCase() == "empresa rechazada por adm"
                        && (permissions.solicitudFunctionsAllowed.Modificacion == true);

                    if (completadaResult || confirmadaResult || denegadaResult || ctpResult || ctrResult || erResult) {
                        permissions.components.BotonNuevaTarjeta.Active = true;
                        permissions.components.BotonGuardarBorrador.Active = true;
                    }

                    if (permissions.solicitudFunctionsAllowed.Baja == true) {
                        permissions.components.IconoEliminar.Active = true;
                    }
                }
                else {
                    /*Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que 
                    no será capaz de acceder a la pantalla*/
                    permissions.components.Pantalla = { Active: false }
                };
                break;
            }
            case "enviada": {
                if (permissions.solicitudFunctionsAllowed.Consulta == true) {
                    permissions.components.Pantalla.Active = true
                    permissions.components.BotonesAnteriorSiguiente.Active = true;

                    permissions.components.BotonDistribuirLimites = { Active: true, Locked: true };
                    permissions.components.IconoEliminar = { Active: true, Locked: true };
                    permissions.components.IconoEditar = { Active: true, Locked: true };
                    permissions.components.BotonNuevaTarjeta = { Active: true, Locked: true };
                    permissions.components.BotonGuardarBorrador = { Active: true, Locked: true };
                }
                else {
                    /*Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que 
                    no será capaz de acceder a la pantalla*/
                    permissions.components.Pantalla = { Active: false }
                };
                break;
            }
            default: {
                break;
            }
        }
    }
    else {
        if (permissions.adminEmpCueTarFunctionsAllowed.Alta == true) {
            permissions.components.Pantalla.Active = true;
            permissions.components.IconoEditar.Active = true;
            permissions.components.BotonNuevaTarjeta.Active = true;
            permissions.components.BotonGuardarBorrador.Active = true;

            if (permissions.solicitudFunctionsAllowed.Consulta == true) {
                permissions.components.BotonesAnteriorSiguiente.Active = true;
            }
            if (permissions.solicitudFunctionsAllowed.Distribucion == true) {
                permissions.components.BotonDistribuirLimites.Active = true;
            }
            if (permissions.solicitudFunctionsAllowed.Baja == true) {
                permissions.components.IconoEliminar.Active = true;
            }
        }
        else {
            /*Si no tiene permisos sobre el alta, no es necesario que valide las demas funciones, ya que no
            será capaz de acceder a la pantalla*/
            permissions.components.Pantalla.Active = false;
        }
    }

    //_dispatch({ type: SET_PERMISOS_SOLICITUD_TARJETA, result: permissions });

    //Si tiene el permiso, carga los datos iniciales de la pantalla
    if (permissions.components.Pantalla.Active == true) {
        _loadData(permissions);
    }
}

/**
 * Carga los dataSources para traer los datos iniciales
 */
function _loadData(permissions) {
    LogHelper.In(_loadData.name, permissions);

    let produtoIdcuentaSeleccionada = _tarjetas.cuentas.find(x => x.seleccionada == true).ProductoId;

    let params = {
        'ADMINISTRADORA_ID': _tarjetas.administradora.Id,
        'PRODUCTO_ID': produtoIdcuentaSeleccionada
    }
    let paramAdm = {
        'ADMINISTRADORA_ID': _tarjetas.administradora.Id,
        'PRODUCTO_ID': produtoIdcuentaSeleccionada
    }

    let paramsGetDatosProductoById = {
        'PRODUCTO_ID': produtoIdcuentaSeleccionada
    }

    LogHelper.Out(_loadData.name, paramAdm, 'GET_CODIGO_DISTRIBUCION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramAdm, 'GET_CODIGO_DISTRIBUCION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadData.name, params, 'GET_TIPO_TARJETA_ADMINISTRADORA_PRODUCTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_TIPO_TARJETA_ADMINISTRADORA_PRODUCTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadData.name, null, 'GET_VIGENCIA_TARJETA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_VIGENCIA_TARJETA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadData.name, null, 'GET_LIMITE_COMPRA_MIN', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_LIMITE_COMPRA_MIN', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadData.name, paramsGetDatosProductoById, 'GET_PRODUCTO_VISA_PRODUCTO_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramsGetDatosProductoById, 'GET_PRODUCTO_VISA_PRODUCTO_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadData.name, paramsGetDatosProductoById, 'GET_DATOS_PRODUCTO_BY_ID', "Get", 'Tarjetas', 'ADMINPRODUCTOS', 1, "Product");
    Engine1Proxy.AddDataSourcesRequests(paramsGetDatosProductoById, 'GET_DATOS_PRODUCTO_BY_ID', "Get", 'Tarjetas', 'ADMINPRODUCTOS', 1, "Product");

    LogHelper.Out(_loadData.name, null, 'GET_ATLAS_ESTADO_CIVIL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ATLAS_ESTADO_CIVIL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadData.name, null, 'GET_ATLAS_NACIONAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ATLAS_NACIONAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadData.name, null, 'GETTIPODOCUMENTO', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(null, 'GETTIPODOCUMENTO', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

    Engine1Proxy.Execute(_loadNewRequestCreateCardInitialStateData, null, permissions, "SOLICITUD");
}

/**
 * Setea datos iniciales
 * @param {any} data
 */
function _loadNewRequestCreateCardInitialStateData(data) {
    LogHelper.In(_loadNewRequestCreateCardInitialStateData.name, data);

    let tipoTarjetaIndicadaEnProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset0.Rows[0].DefaultTipoTarjetaId;
    let tipoTarjetas = JSON.parse(data.GET_TIPO_TARJETA_ADMINISTRADORA_PRODUCTO).Recordset0.Rows;
    let tipoTarjetaSeleccionada = tipoTarjetas.find(x => x.Id == tipoTarjetaIndicadaEnProducto);
    let defaultCodigoDistribucionId = JSON.parse(data.GET_PRODUCTO_VISA_PRODUCTO_ID).Recordset0.Rows[0].DefaultCodigoDistribucionId;
    let codigosDistribucion = JSON.parse(data.GET_CODIGO_DISTRIBUCION).Recordset0.Rows;
    let codigoDistribucion = codigosDistribucion.find(x => x.Id == defaultCodigoDistribucionId);
    let atlasEstadoCivil = JSON.parse(data.GET_ATLAS_ESTADO_CIVIL).Recordset0.Rows;
    let atlasNacional = JSON.parse(data.GET_ATLAS_NACIONAL).Recordset0.Rows;
    let tiposDeDocumentos = JSON.parse(data.GETTIPODOCUMENTO);

    let result = {
        id: _tarjetas.id,
        permisos: data.CALLER_ID,
        cliente: _tarjetas.cliente,
        empresas: _tarjetas.empresas,
        administradora: _tarjetas.administradora,
        cuentas: _tarjetas.cuentas,
        tipoEmpresa: _tarjetas.tipoEmpresa,
        tarjetas: _tarjetas.tarjetas,
        tipoTarjeta: tipoTarjetas,
        dias: JSON.parse(data.GET_VIGENCIA_TARJETA).Recordset0.Rows,
        minValueLimite: JSON.parse(data.GET_LIMITE_COMPRA_MIN).Recordset0.Rows[0].Valor,
        tipoTarjetaIndicadaEnProducto: JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset0.Rows[0].DefaultTipoTarjetaId,
        codigoTipoTarjeta: tipoTarjetaSeleccionada ? tipoTarjetaSeleccionada.Codigo : undefined,
        codigoDistribucion,
        codigosDistribucion,
        atlasEstadoCivil: atlasEstadoCivil,
        atlasNacional: atlasNacional,
        tiposDeDocumentos
    };

    result.numeroTarjetas = result.tarjetas.length + 1;

    _dispatch({ type: ACTUALIZAR_ESTADO_DISTRIBUCION_TARJETA });
    _dispatch({ type: GET_ACCOUNT_DATA_RESULT, result });
}

/**
 * 
 * @param {any} valueHeadline
 * @param {any} state
 */
function _obtenerTitular(valueHeadline, state, tipoDocumento) {
    LogHelper.In(_obtenerTitular.name, valueHeadline, state, tipoDocumento);

    let esNumerico;
    let reNum = new RegExp("^[0-9]+$");

    if (reNum.test(valueHeadline)) {
        esNumerico = true;
    }
    else {
        esNumerico = false;
    }

    if (esNumerico) {
        let cuentaSeleccionada = _tarjetas.cuentas.find(x => x.seleccionada);
        let parametro = {
            'NRO_DOC': parseInt(valueHeadline),
            'CUENTA_TARJETA_ID': cuentaSeleccionada.Id != undefined ? cuentaSeleccionada.Id : 0,
            'TIPO_DOCUMENTO_ID': tipoDocumento
        }

        LogHelper.Out(_obtenerTitular.name, parametro, 'GET_CLIENTE_NRODOC', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_CLIENTE_NRODOC', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.Execute((data) => _loadGetClienteNroDoc(data, valueHeadline, tipoDocumento), null, null, "SOLICITUD");
    }
    else {
        if (state.titularCard != undefined) {
            if (state.titularCard.length > 1) {
                state.headline = state.titularCard[0].Nombre + " " + state.titularCard[0].Apellido;
                state.idTitular = state.titularCard[0].Id;
                state.denominationCard = state.titularCard[0].Apellido + "/" + state.titularCard[0].Nombre;
            }
            else {
                if (state.titularCard.length != undefined) {
                    state.titularCard.map(function (row) {
                        let comprobarNombreYapellido = row.Nombre + " " + row.Apellido;
                        if (comprobarNombreYapellido == valueHeadline) {
                            state.headline = row.Nombre + " " + row.Apellido;
                            state.idTitular = row.Id;
                            state.denominationCard = row.Apellido + "/" + row.Nombre;
                        }
                    });
                }
                else {
                    state.headline = state.titularCard.Nombre + " " + state.titularCard.Apellido;
                    state.idTitular = state.titularCard.Id;
                    state.denominationCard = state.titularCard.Apellido + "/" + state.titularCard.Nombre;
                }
            }

            _dispatch({ type: GET_HEADLINE, result: state });
        }
    }
}

/**
 * 
 * @param {any} data
 * @param {any} documento
 */
function _loadGetClienteNroDoc(data, documento, tipoDocumento) {
    LogHelper.In(_loadGetClienteNroDoc.name, data, documento);

    let result = {};
    result.titularCard = JSON.parse(data.GET_CLIENTE_NRODOC).Recordset0.Rows;

    if (result.titularCard.length == 0) {
        if (documento != undefined) {
            buscarTitular(documento, tipoDocumento);
        }
        else {
            _dispatch({ type: OBTENER_TITULAR_SOLICITUD_TARJETAS, result });
        }
    }
    else {
        if (result.titularCard.length >= 1) {
            result.titularCard = result.titularCard[0];
        }
        obtenerDatosTitularBD(result);
    }
}

/**
 * 
 * @param {any} documento
 */
function buscarTitular(documento, tipoDocumento) {
    LogHelper.In(buscarTitular.name, documento);

    let valorParseado = parseInt(documento);
    let valorString = valorParseado.toString();

    let parametroDatosFiliatorios = {
        'DOCUMENTO': valorParseado,
        'SOLO_PERSONA_FISICA': true,
        'TIPO_DOCUMENTO_ID': tipoDocumento
    }

    LogHelper.Out(buscarTitular.name, parametroDatosFiliatorios, 'GETCLIENTEDATOSFILIATORIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametroDatosFiliatorios, 'GETCLIENTEDATOSFILIATORIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.Execute(_callBackBuscarPorDocumentoDatosFiliatorios, null, null, "SOLICITUD");
}

/**
 * 
 * @param {any} data
 * @param {any} documento
 */
function _callBackBuscarPorDocumentoDatosFiliatorios(data) {
    LogHelper.In(_callBackBuscarPorDocumentoDatosFiliatorios.name, data);

    if (data != undefined) {
        if (!data.devuelveError && data.GETCLIENTEDATOSFILIATORIOS != "null") {
            obtenerDatosTitular(data);
        }
        else {
            let result = {};
            result.titularCard = [];

            _dispatch({ type: OBTENER_TITULAR_SOLICITUD_TARJETAS, result });
        }
    }
    else {
        let result = {};
        result.titularCard = [];

        _dispatch({ type: OBTENER_TITULAR_SOLICITUD_TARJETAS, result });
    }
}

/**
 * 
 * @param {any} respuesta
 */
function obtenerDatosTitular(respuesta) {
    LogHelper.In(obtenerDatosTitular.name, respuesta);

    let datosFiliatorios = JSON.parse(respuesta.GETCLIENTEDATOSFILIATORIOS);
    let error = "";

    if (!datosFiliatorios.CategoriaIVA) {
        error += "No tiene cargada la Categoria IVA\n"
    }

    if (!datosFiliatorios.EstadoCivil) {
        error += "No tiene cargado el Estado Civil\n"
    }

    if (!datosFiliatorios.Nacionalidad) {
        error += "No tiene cargada la Nacionalidad\n"
    }

    if (!datosFiliatorios.TipoDocumento) {
        error += "No tiene cargado el Tipo Documento\n"
    }

    //El TipoIIBB puede venir NULL
    //if (!datosFiliatorios.TipoIIBB) {
    //    error += "No tiene cargado el Tipo IIBB\n"
    //}

    if (error == "") {
        _dispatch({ type: OBTENER_TITULAR_SOLICITUD_TARJETAS, result: datosFiliatorios });
    }
    else {
        alert(error);
    }
}

/**
 * 
 * @param {any} respuesta
 */
function obtenerDatosTitularBD(result) {
    LogHelper.In(obtenerDatosTitularBD.name, result);

    let error = "";

    if (result.titularCard.NacionalidadId == null) {
        error += "No tiene cargada la Nacionalidad\n"
    }

    if (result.titularCard.EstadoCivilId == null) {
        error += "No tiene cargado el Estado Civil\n"
    }

    //El TipoIIBB puede venir NULL
    //if (!datosFiliatorios.TipoIIBB) {
    //    error += "No tiene cargado el Tipo IIBB\n"
    //}

    if (error == "") {
        _dispatch({ type: OBTENER_TITULAR_SOLICITUD_TARJETAS, result });
    }
    else {
        alert(result.titularCard.SolicitudId == null ? "Cliente cargado por fuera de adintar.\n" + error : "Cliente cargado por adintar.\n" + error);
        _dispatch({ type: FRENAR_SPINNER_SOLICITUD_TARJETAS });
    }
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/NuevaSolicitudTarjeta/actions/NuevaSolicitudTarjetaActions.js